import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { SystemSpecificationEvents } from 'icreate/common/io-event/websocket-message';

@Injectable({
    providedIn: 'root',
})
export class SystemSpecificationSocketService {
    constructor(private socketService: SocketMiddlewareService) {}

    specificationsUpdated$() {
        return this.socketService.receiveMessageObserver(SystemSpecificationEvents.SPECIFICATIONS_UPDATED);
    }
}
